// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3v-H0","subheader":"ReorderModal_subheader__1kZhV","listWrap":"ReorderModal_listWrap__3o434"};